import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CustomPipesModule } from 'src/app/_pipes/custom-pipes.module';
import { DeleteAccountConfirmationDialog } from './delete-account-confirmation-dialog';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
    CustomPipesModule,
  ],
  declarations: [DeleteAccountConfirmationDialog],
})
export class DeleteAccountConfirmationDialogModule {}
